import { Injectable } from '@angular/core';
import { Jwt } from '@models/system';

@Injectable({
    providedIn: 'root'
})
export class JwtService {

    static save(jwt: Jwt) {

        localStorage.setItem('jwt', JSON.stringify(jwt));
    }

    static get(): Jwt {

        let s = localStorage.getItem('jwt')?.toString();
    
        if (s == undefined) {
            throw new Error('Jwt not set');
        }

        let jwt = <Jwt>JSON.parse(s);

        if (new Date(jwt.payload.exp) <= new Date()) {
            throw new Error('Jwt expired');
        }
            
        return jwt;  
        
    }

    static clear() {
      
        localStorage.removeItem('jwt');
    }

    static uid(): number {
        
        return JwtService.get().payload.uid;
    }

    /*
    public username(): string | undefined {
        
        return atob(this.auth.substr(6)).split(":", 1).shift();
    }

    public password(): string | undefined {
        
        return atob(this.auth.substr(6)).split(":", 2).pop();
    }
    */

}
